import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'open_with_faire-submit_application_tier-click';

/**
 * Record event when submitting open with faire form that says what tier of the form the retailer is submitting
 */
export function trackOpenWithFaireSubmitApplicationTierClick(
  customParameterToken: string,
  customParameterToken2: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { customParameterToken, customParameterToken2 },
  });
}
